import React from 'react';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import InfinityIcon from '@mui/icons-material/AllInclusive';
import CloseIcon from '@mui/icons-material/Close';

interface InfinityDateInputProps {
  value: string;
  label: string;
  isIndefinite: boolean;
  onClear: () => void;
  onSetInfinite: () => void;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
}

const InfinityDateInput = ({
  value,
  label,
  isIndefinite,
  onClear,
  onSetInfinite,
  onChange,
  required,
  disabled,
}: InfinityDateInputProps) => {
  const dateValue = isIndefinite ? '' : value;

  return isIndefinite ? (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          ml: 3,
        }}
      >
        <InfinityIcon style={{ color: 'grey' }} />
      </Box>
      <IconButton onClick={onClear} disabled={disabled}>
        <CloseIcon />
      </IconButton>
    </Box>
  ) : (
    <TextField
      type='date'
      InputLabelProps={{ shrink: true }}
      value={dateValue}
      onChange={(event) => onChange(event.target.value)}
      required={required}
      label={label}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton onClick={onSetInfinite} disabled={disabled}>
              <InfinityIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
      disabled={disabled}
      fullWidth
    />
  );
};

export default InfinityDateInput;
